<template>
	<div>
    <div class="core-function">
      <div class="title">核心功能</div>
      <div class="box">
        <div  class="item" v-for="item in coreFunction" :key="item.id">
          <img :src="item.src" />
          <div class="title">{{item.title}}</div>
          <div class="description">{{item.content}}</div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
	export default {
		name: 'coreFunction',
		data() {
      return {
        coreFunction: [{
          id: 0,
          title: '容器引擎MCE',
          content: '以应用为中心，提供配置、存储、镜像仓库等完整的容器引擎模块，支持应用的弹性伸缩、高可用、负载均衡等特性',
          src: require('@/assets/images/mcebox.png')
        }, {
          id: 1,
          title: '持续交付',
          content: '通过可视化的流水线设计任务，对构建、测试、部署等各类任务做流程化设计，一键完成持续/交付工作',
          src: require('@/assets/images/deliver.png')
        }, {
          id: 2,
          title: '资源编排',
          content: '可视化的编辑界面，以编辑YAML文件的方式设计复杂的应用模板，简化应用部署难度并提升灵活性',
          src: require('@/assets/images/resources.png')
        }, {
          id: 3,
          title: '数据库',
          content: '多样化的数据库类型，丰富的配置管理项，支持扩容、备份还原、监控等',
          src: require('@/assets/images/database.png')
        }, {
          id: 4,
          title: '微服务',
          content: '基于Spring Cloud构建完整的微服务治理体系，支持服务发现、熔断、负载均衡、配置及调度分析',
          src: require('@/assets/images/service.png')
        }, {
          id: 5,
          title: '智能运维',
          content: '应用层面实现负载均衡、弹性扩容、故障自动恢复等功能，并配备监控告警、健康检查和自动化作业平台等智能化运维工具',
          src: require('@/assets/images/smartsre.png')
        }],
      }
    }
	}
</script>

<style>
	@media (min-width:992px) {
    .core-function {}

    .core-function .title {
      margin: 120px auto 0;
      width: 120px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
    }

		.core-function .box {
      width: 1400px;
      margin: 60px auto 120px;
      display: flex;
      flex-flow: row wrap;
      align-items: start;
      justify-content: space-between;
		}

		.core-function .box .item {
			height: 329px;
			width: 380px;
		}

    .core-function .box .item img {
      margin: 36px auto 0;
    }

    .core-function .box .item .title {
      margin: 33px auto 0;
      width: 164px;
      height: 37px;
      font-size: 26px;
      font-weight: 500;
      color: #3B3A40;
      line-height: 37px;
    }

    .core-function .box .item .description {
      margin: 33px auto 0;
      width: 310px;
      height: 78px;
      font-size: 16px;
      font-weight: 400;
      color: #64626A;
      line-height: 26px;
      opacity: 0.8;
    }

		.core-function .box .item:hover {
			border-bottom: 4px solid #3890FF;
			box-shadow: 0px 2px 7px 0px rgba(158, 158, 237, 0.4);
			margin-bottom: -7px;
		}
    .core-function .box .item .up {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-bottom: 33px;
    }

    .core-function .box .item .up h4 {
      margin: 24px 0 0 24px;
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.1;
    }

    .core-function .box .item p {
      text-align: left;
      color: #777;
      font-size: 14px;
      line-height: 1.5;
    }
	}

	@media (max-width:992px) {
    .core-function {
      padding: 6vw 3vw;
    }

    .core-function .title {
      margin: 0 auto 6vw;
      font-size: 16px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 20px;
    }

    .core-function .box {
      width: 100%;
      margin: 6vw auto 0;
      display: grid;
      grid-template-columns: repeat(2, 50%);
    }

    .core-function .box .item {
      width: 45vw;
      margin-bottom: 4vw;
    }

    .core-function .box .item img {
      width: 30vw;
      height: 30vw;
      margin: 3vw auto 0;
    }

    .core-function .box .item .title {
      margin: 6vw auto 0;
      font-size: 16px;
      font-weight: 400;
      color: #3B3A40;
      line-height: 20px;
    }

    .core-function .box .item .description {
      margin: 3vw auto 0;
      font-size: 12px;
      color: #64626A;
      line-height: 16px;
      opacity: 0.8;
    }
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/CoreFunction.vue